export default {
  disableClick: {
    pointerEvents: "none",
    cursor: "default",
    color: "black",
  },
};
